import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	MOBILE_L_BP,
	FONT_WT_LIGHT,
	FONT_WT_EXTRA_BOLD,
} from "@website-builder/utilities-index";

export const InfoWrapper = styled.div`
	padding: 30px 0;
	display: flex;
	flex-flow: wrap;
	justify-content: center;
	.infoBlock {
		display: flex;
		margin-left: 35px;
		margin-right: 35px;
		.infoHeading {
			font-size: 16px;
			font-weight: ${FONT_WT_EXTRA_BOLD};
			line-height: 24px;
			text-align: center;
			color: ${COLOR_TEXT_PRIMARY_B2C};
			margin-right: 2px;
		}
		.infoContent {
			font-size: 16px;
			font-weight: ${FONT_WT_LIGHT};
			line-height: 24px;
			text-align: center;
			color: ${COLOR_TEXT_PRIMARY_B2C};
			margin-left: 2px;
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP - 1}px) {
		padding: 25px 0px;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 25px 10px;
		.infoBlock {
			margin-left: 5px;
			margin-right: 5px;
		}
	}
`;
